import { Mensagem } from './../../../mensagem/models/mensagem.model';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AnuncioService } from 'app/anuncio/services/anuncio.service';
import { AnuncioSituacaomEnum } from 'app/shared/enum/anuncio-situacao.enum';
import { OrigemEnum } from 'app/shared/enum/origem.enum';
import { AnuncioUtil } from 'app/shared/services/anuncio.util';
import { AuthService } from 'app/shared/services/auth.service';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Anuncio } from '../../models/anuncio.model';
import { CadastroAnuncioService } from '../../services/cadastro-anuncio.service';
import { AnuncioInteresseSituacaomEnum } from 'app/shared/enum/anuncio-interesse-situacao.enum';
import { eInteresseCancelado } from 'app/shared/services/interessesutil';
import { AnuncioTipoEnum } from 'app/shared/enum/anuncio-tipo.enum';
import { AnuncioOrigem, AnuncioOrigemEnum } from 'app/anuncio/models/anuncio-origem.model';

@Component({
  selector: 'reuse-anuncio-item-novo',
  templateUrl: './anuncio-item-novo.component.html',
  styleUrls: ['./anuncio-item-novo.component.scss']
})
export class AnuncioItemNovoComponent implements OnInit {

  @Input() anuncio: Anuncio = {} as Anuncio;
  @Input() origem?: string;

  @Output()
  liberarFinalizarAnuncio = new EventEmitter<Anuncio>();

  @Output()
  alterarTipoAnuncio = new EventEmitter<Anuncio>();

  fotoCapa: any = 'assets/img/sem-imagem-galeria.png';
  carregandoFoto = false;
  larguraFotoCapa?: number;
  alturaFotoCapa?: number;
  zoomFotoCapa = 1;

  constructor(
    private router: Router,
    private confirmationService: ConfirmationService,
    private cadastroAnuncioService: CadastroAnuncioService,
    private messageService: MessageService,
    public anuncioUtil: AnuncioUtil,
    public authService: AuthService,
    public anuncioService: AnuncioService,
  ) { }

  ngOnInit() {
    this.obterFotoCapa();
  }

  public obterFotoCapa() {
    if (this.anuncio && this.anuncio.permissoes.podeVisualizarFoto) {
      this.carregandoFoto = true;
      this.anuncioService.obterFotoCapa(this.anuncio).subscribe(data => {
        this.carregandoFoto = false;
        if (data) {
          this.fotoCapa = data.fotoGaleria;
        }
      }, error => {
        this.carregandoFoto = false;
      });
    }
  }

  private createImageFromBlob(image: Blob) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.fotoCapa = reader.result;
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  /**
   * Opção disponível apenas para Anúncios que estiverem na
   * Situação 'Ativo' e cuja
   * Data de Validade seja igual ou posterior à data atual do sistema.
   */
  public exibirBotoesAlterarInteresse(): boolean {
    return this.origem === OrigemEnum.MEUS_INTERESSES &&  this.anuncio && this.anuncio.permissoes.podeAlterarInteresse;
  }

  public exibirBotaoAlterarAnuncio(): boolean {
    return (
      this.origem === OrigemEnum.MEUS_ANUNCIOS_GOVERNO ||
      this.origem === OrigemEnum.MEUS_ANUNCIOS_PRIVADO
    ) && this.anuncio !== undefined && this.anuncio.permissoes.podeAlterar && this.anuncio.anuncioSituacao.id != AnuncioSituacaomEnum.ANUNCIO_FINALIZADO;
  }

  public exibirBotaoExcluir(): boolean {
    return (this.origem === OrigemEnum.MEUS_ANUNCIOS_GOVERNO || this.origem === OrigemEnum.MEUS_ANUNCIOS_PRIVADO) &&
      this.anuncio !== undefined && this.anuncio.permissoes.podeExcluir;
  }

  public exibirBotaoInativar(): boolean {
    return (this.origem === OrigemEnum.MEUS_ANUNCIOS_GOVERNO || this.origem === OrigemEnum.MEUS_ANUNCIOS_PRIVADO) &&
      this.anuncio !== undefined  &&  this.anuncio.permissoes.podeInativar;
  }

  public exibirBotaoAtenderComplementacao(): boolean {
    return this.origem === OrigemEnum.MEUS_ANUNCIOS_PRIVADO
      && this.anuncio !== undefined && this.anuncio.permissoes.podeAtenderComplementacao;
  }

  public exibirQuantidadesUnidades(): boolean {
    return this.anuncio !== undefined && this.anuncio.unidadeFornecimento.id != -1;
  }

  public exibirStatusAnuncio() {
    if (this.anuncio !== undefined && this.anuncio.anuncioSituacao.id == AnuncioSituacaomEnum.EM_ANALISE_DENUNCIA) {
      return this.authService.hasRole(['SEGES']);
    }
    return this.anuncio !== undefined && this.anuncio.anuncioSituacao.id != AnuncioSituacaomEnum.ATIVO;
  }

  public ehAnuncioLei14_479(): boolean {
    return this.anuncioUtil.ehAnuncioLei14_479(this.anuncio!);
  }

  /**
 * Verifica se o anúncio é do tipo Governo ou Privado
 */
  public getClasseAnuncioPrivadoOuGoverno(): String {
    if (this.anuncioUtil.anuncioPrivado(this.anuncio!)) {
      return "anuncioPrivado";
    } else {
      return "anuncioGoverno";
    }
  }

  /**
   * Comportamento ao clicar em um anúncio, redireciona para página de detalhamento.
   */
  public clicouAnuncio(): void {
    this.router.navigate(['/' + this.origem, this.anuncio.id]);
  }

  /**
   * Clique botão 'Alterar interesse'.
   */
  public alterarInteresse(event: MouseEvent): void {
    //quando clicar no botão não deve disparar evento 'clicouAnuncio'
    event.stopPropagation();

    this.router.navigate(['/' + this.origem, this.anuncio.id, 'tenho-interesse']);
  }

  /**
   * Clique botão 'Alterar anúncio'.
   */
  public alterarAnuncio(event: MouseEvent): void {
    //quando clicar no botão não deve disparar evento 'clicouAnuncio'
    event.stopPropagation();

    if (this.anuncioUtil.anuncioGoverno(this.anuncio)) {
      this.router.navigate(['/' + OrigemEnum.ALTERAR_CADASTRO_ANUNCIO_GOVERNO, this.anuncio.id]);
    } else {
      this.cadastroAnuncioService.verificarBloqueado(this.anuncio.id).subscribe(
        () => {
          this.router.navigate(['/' + OrigemEnum.ALTERAR_CADASTRO_ANUNCIO_PRIVADO, this.anuncio.id]);
        });
    }
  }

  public liberarFinalizarAnuncioAction(event: MouseEvent): void {
    event.stopPropagation();
    this.liberarFinalizarAnuncio.emit(this.anuncio);
  }

  podeLiberarFinalizarAnuncio(): boolean {
    return this.anuncio.anuncioTipo.id === AnuncioTipoEnum.TIC
    && this.anuncio.republicacaoMotivo == null
    && this.origem === OrigemEnum.MEUS_ANUNCIOS_GOVERNO;
    ;
  }

  podeRetornarParaTIC(): boolean {
    return this.anuncio.anuncioTipo.id === AnuncioTipoEnum.TIC  && this.anuncio.republicacaoMotivo != null;
  }

  podeAlterarTipoAnuncio(): boolean {
    if( this.anuncio.anuncioSituacao.id === AnuncioSituacaomEnum.ATIVO
      && !(this.anuncio.anuncioTipo.id === AnuncioTipoEnum.TIC)
      && this.anuncio.permissoes.podeAlterar
    ){
      return true;
    }
    return false;
  }

  public alterarTipoAnuncioAction(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.alterarTipoAnuncio.emit(this.anuncio);
  }

  public atenderComplementacao(event: MouseEvent): void {
    //quando clicar no botão não deve disparar evento 'clicouAnuncio'
    event.stopPropagation();

    this.cadastroAnuncioService.verificarBloqueado(this.anuncio.id).subscribe(
      () => {
        this.router.navigate(['/' + OrigemEnum.ALTERAR_CADASTRO_ANUNCIO_PRIVADO, this.anuncio.id]);
      });
  }

  /**
   * Clique botão 'Excluir interesse'.
   * Direciona para a página de detalhes com parâmetro excluir
   */
  public cancelarInteresse(event: MouseEvent): void {
    //quando clicar no botão não deve disparar evento 'clicouAnuncio'
    event.stopPropagation();

    this.router.navigate(['/' + this.origem, this.anuncio.id], { queryParams: { parametro: 'excluir' } });
  }

  /**
   * Clique botão 'Excluir anúncio'.
   */
  public excluirAnuncio(event: MouseEvent): void {
    //quando clicar no botão excluir não deve disparar evento 'clicouAnuncio'
    event.stopPropagation();

    this.confirmationService.confirm({
      key: `modal_${this.anuncio.id}`,
      message: `Confirma a exclusão do Anúncio ${this.anuncio.id}?`,
      accept: () => {
        this.confirmouExclusaoAnuncio();
      }
    });
  }


  public inativarAnuncio(event: MouseEvent): void {
    event.stopPropagation();
    this.confirmationService.confirm({
      key: `modal_${this.anuncio.id}`,
      message: `Confirma a inativação do Anúncio ${this.anuncio.id}?`,
      accept: () => {
        this.confirmouInativarAnuncio();
      }
    });
  }

  public retornarParaTIC(event: MouseEvent): void {
    event.stopPropagation();
    this.confirmationService.confirm({
      key: `modal_${this.anuncio.id}`,

      message: `Ao alterar para "Anúncio de Bens de TIC",
      o anúncio ficará indisponível para manifestação de interesse.
      Essa classificação indica destinação ao Programa Computadores para Inclusão, conforme a <b>Lei nº 14.479, de 21 de dezembro de 2022</b>.
      <br>
      Deseja confirmar?`,
      accept: () => {
        this.confirmouRetornarParaTIC();
      }
    });
  }

  private confirmouRetornarParaTIC(): void {
    this.anuncio.republicacaoMotivo = null;
    this.cadastroAnuncioService.atualizarAnuncioGoverno(this.anuncio).subscribe(
      (resultado: any) => {
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: resultado.mensagem });
        setTimeout(() => window.location.reload(), 1000);
      });
  }

  private confirmouExclusaoAnuncio(): void {
    this.anuncioService.excluirAnuncio(this.anuncio.id).subscribe(
      (resultado: any) => {
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: resultado.mensagem });
        setTimeout(() => window.location.reload(), 1000);
      });
  }

  private confirmouInativarAnuncio(): void {
    if (this.anuncioUtil.anuncioPrivado(this.anuncio) || this.anuncioUtil.anuncioGoverno(this.anuncio)) {
      this.anuncioService.inativarAnuncio(this.anuncio.id).subscribe(
        (resultado: any) => {
          this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: resultado.mensagem });
          setTimeout(() => window.location.reload(), 1000);
        }
      )
    }
  }

  public eInteresseCancelado(): boolean {
    return eInteresseCancelado(this.anuncio);
  }

  public origemMeusAnunciosInteresse(): boolean {
    return this.origem == OrigemEnum.MEUS_ANUNCIOS_INTERESSES;
  }

  obterDimensoes(img: HTMLImageElement) {
    this.larguraFotoCapa = img.naturalWidth;  // Largura real da imagem
    this.alturaFotoCapa = img.naturalHeight;  // Altura real da imagem
    let alturaDefault = img.clientHeight;
    let larguraDefault =  img.clientWidth;
    let alturaProporcao =alturaDefault/ this.alturaFotoCapa;
    let larguraProporcao = larguraDefault/ this.larguraFotoCapa;
    if(alturaProporcao > 1 || larguraProporcao > 1){
      if( alturaProporcao > 1.25 || larguraProporcao > 1.25){
        this.zoomFotoCapa = 1.25;
      }else if(alturaProporcao >  larguraProporcao){
        this.zoomFotoCapa = alturaProporcao;
      }else{
        this.zoomFotoCapa = larguraProporcao;
      }
    }
  }
}
